import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistDocument } from "../../Persist/AbstractDocumentPersister";
import { stageMetaDataDocument } from "../../Stages/StagesDocument";
import * as documentStages from "../../Stages/StagesDocument";
import * as documentStatus from "../../LeadStatus/StatusDocument";
import documentTransformations from "../FormTransformations/documentTransformations";
import { stageFormDefinition as stageFormDefinitionDocument } from "../FormDefinitions/document";
import formDefinitionExternals from "../FormDefinitions/externals";
import { fullFormDefinition as fullFormDefinitionDeath } from "../FormDefinitions/document/death";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";
import { Death } from "../../../types/Products/Document/Death/Death";

export const death: ProductData<Death> = {
  urlPart: "tod",
  lbUrlPart: "todesfall",
  label: translate("death.label"),
  generalLabel: translate("death.label"),
  apiUri: "deaths",
  persist: persistDocument,
  stages: stageMetaDataDocument,
  stageConstants: documentStages,
  minimumCaseStatus: documentStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: documentStages.STAGE_INCOMPLETE,
  setBackCaseStage: documentStages.STAGE_READY,
  paymentType: {
    creditcard: "Kreditkarte",
    paypal: "Paypal",
    sofort: "Sofortüberweisung",
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: () => false,
  lbProductClass: "App\\Entity\\Legalbird\\Document\\Death",
  formTransformations: documentTransformations,
  formDefinition: ({ product }) => stageFormDefinitionDocument(product.productClassName),
  formDefinitionExternals: () => formDefinitionExternals["death"],
  fullFormDefinition: ({ product }) => fullFormDefinitionDeath(product),
  productSpecificDefinition: () => [],
  productCategory: "familyLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: () => false,
  inquiryTypeAvailability: inquiryTypeAvailability.death,
}
